const getters = {
  token: (state) => state.user.token,
  phone: (state) => state.user.phone,
  name: (state) => state.user.name,
  avatar: (state) => state.user.avatar,
  path: (state) => state.app.path,
  path_name: (state) => state.app.path_name,
  model: (state) => state.app.model,
};
export default getters;
